module.exports = __webpack_public_path__ + "static/media/herosectionimage.2458f812.gif";